
//山东矿机培训管理系统配置
const state = {
  systemTitle: "山东矿机培训管理系统",
  wxConfig: {
    //微信公众号的appid
    appid: "wx95f7ba638b78111d",
    // appid: "wx29580ae4751e4155",
    // 微信登录授权、微信登录授权的路径配置一样
    // urlVerify: "sanjianqu.hlgoing.com",
    urlVerify: "ks.sdkjjt.com",
    // urlVerify: "200.200.201.18:8082",
    //系统webUrl
    // webUrl: "sanjianqu.hlgoing.com",
    webUrl: "ks.sdkjjt.com",
    // webUrl: "200.200.201.18:8082",
  }
}


export default {
  namespaced: true,
  state
}